import { useContext } from "react";
import AppUserContext from "ooAuth2/appUserContext";
import { AppUser } from "ooAuth2/appUser";


const useAppUser = ():AppUser|undefined=>{
    const appUser:AppUser = useContext(AppUserContext);
    return appUser;
}

export default useAppUser;
